import { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import useSpmoDetail from "./useSpmoDetail"
import { useAuth } from "../../../hooks/useAuth"
import ArrowBackButton from "../../../components/button/ArrowBackButton"
import ApprovalModal from "../component/ApprovalModal"
import JustificationModalLatest from "../../activeProjectPage/detailCurrentProject/justificationComponent/JustificationModalLatest"
import Loading from "../../../components/loading/Loading"
import CalibrationTableSpmo from "./component/CalibrationTableSpmo"
import AcceptAllModal from "./component/AcceptAllModal"
import SubmitModal from "./component/SubmitModal"
import ScoreDistributionSPMO from "./component/ScoreDistributionSPMO"
import Chart from "../../activeProjectPage/detailCurrentProject/components/Chart"
import ActionButtonGradient from "../../../components/button/ActionButtonGradient"

const SpmoDetail = () => {
    const params = useParams()
    const {getCurrentUser} = useAuth()
    const [phase, setPhase] = useState(0)
    const {
        user,
        getAllCalibrations,
        userApprove,
        setUserApprove,
        isAcceptModal,
        setIsAcceptModal,
        show,
        handleShow,
        handleClose,
        calibrations,
        userJustification,
        showJustification,
        handleCloseJustification,
        multipleAcceptJustification,
        checkBoxes,
        acceptAllJustification,
        canSubmit,
        checkAll, 
        setMultipleJustificationDataByCheckbox,
        submitReview,
        loadingPagestate,
        onChangeHandler,
        canCheckAll,
        setLoadingPage,
        ratingQuota,
        getRatingQuota,
        scoreDistribution,
        getScoreDistribution,
        actualScore,
        countCalibrated,
        deviationRating,
        setDeviationRating,
        averageAllScore,
        updateTable,
        userNameOption,
        gradeOption,
        supervisorNameOption,
        divisionOption,
    } = useSpmoDetail()
    const [phaseOption, setPhaseOption] = useState();

    useEffect(() => {
        if (
            (countCalibrated.APlus > 0 || 
            countCalibrated.A > 0 || 
            countCalibrated.BPlus > 0 || 
            countCalibrated.B > 0 || 
            countCalibrated.C > 0 || 
            countCalibrated.D > 0)&& 
            (ratingQuota.APlus > 0 || 
                ratingQuota.A > 0 || 
                ratingQuota.BPlus > 0 || 
                ratingQuota.B > 0 || 
                ratingQuota.C > 0 || 
                ratingQuota.D > 0)) {
            setDeviationRating({
                Latest: "",
                LatestID: "",
                "APlus": countCalibrated.APlus - ratingQuota.APlus,
                "A": countCalibrated.A - ratingQuota.A,
                "BPlus": countCalibrated.BPlus - ratingQuota.BPlus,
                "B": countCalibrated.B - ratingQuota.B,
                "C": countCalibrated.C - ratingQuota.C,
                "D": countCalibrated.D - ratingQuota.D,
            })
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [countCalibrated, ratingQuota])

    useEffect(() => {
        let user = getCurrentUser()
        if (user.ID && params.calibrator_id && params.business_unit_id && params.order) {
            getAllCalibrations(user.ID, params.calibrator_id, params.business_unit_id, params.order, params.department_name, params.project_id)
            getRatingQuota(user.ID, params.calibrator_id, params.business_unit_id, params.order, params.project_id)
            getScoreDistribution(params.business_unit_id, params.project_id)

            setPhase(parseInt(params.order))

            let data = []
            let phaseValue = -2
            for (let index = parseInt(params.order)-1; index  > 0; index--) {
                data.push({'label':index,'value':phaseValue})
                phaseValue -= 1
            }
            setPhaseOption(data)
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const [showAcceptAll, setShowAcceptAll] = useState(false)
    const handleCloseAcceptAll = () => setShowAcceptAll(false)
    const handleShowAcceptAll = () => setShowAcceptAll(true)

    const [showSubmitModal, setShowSubmitModal] = useState(false)
    const handleCloseSubmitModal = () => setShowSubmitModal(false)
    const handleShowSubmitModal = () => setShowSubmitModal(true)
    const [showScrollBottom, setShowScrollBottom] = useState(false)

    // Scroll event listener for scroll-to-bottom button
    useEffect(() => {
        const handleScroll = () => {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop
            const scrollHeight = document.documentElement.scrollHeight
            const clientHeight = document.documentElement.clientHeight
            
            // Show button when scrolled down and not at bottom
            setShowScrollBottom(scrollTop > 300 && (scrollTop + clientHeight < scrollHeight - 100))
        }

        window.addEventListener('scroll', handleScroll)
        handleScroll() // Check initial position

        return () => window.removeEventListener('scroll', handleScroll)
    }, [])

    const scrollToBottom = () => {
        window.scrollTo({
            top: document.documentElement.scrollHeight,
            behavior: 'smooth'
        })
    }

    return(
        <div className="container-fluid justify-content-center">
            <div>
                {/* Header */}
                <div style={{ marginBottom: '1.5rem' }}>
                    <ArrowBackButton title="My Approval Detail" path={-1} />
                </div>

                {/* Project Info */}
                <div className="flex-row" style={{ justifyContent: 'space-between', marginBottom: '1rem' }}>
                    <p>
                        Calibrator: {' '}
                        <b>{decodeURIComponent(params.calibrator_name || '-')}</b>
                    </p>
                </div>

                {
                    user && checkBoxes ?
                    <>
                        <div className="table-responsive mt-4">
                            <table className="table align-items-center">
                                <tbody>
                                    <tr>
                                        <td style={{marginRight:'1em'}}>
                                            <Chart 
                                                ratingQuota={ratingQuota}
                                                actualScore={actualScore}
                                                calibratedScore={countCalibrated}
                                            />
                                        </td>
                                        <td>
                                            <ScoreDistributionSPMO 
                                                scoreDistribution={scoreDistribution}
                                                ratingQuota={ratingQuota}
                                                totalActualScore={actualScore}
                                                countCalibrated={countCalibrated}
                                                deviationRating={deviationRating}
                                                averageAllScore={averageAllScore}
                                            />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                    <CalibrationTableSpmo
                        calibratedUsers={user}
                        projectPhase={phase}
                        phaseOption={phaseOption}
                        checkAll={checkAll}
                        setMultipleJustificationDataByCheckbox={setMultipleJustificationDataByCheckbox}
                        checkBoxes={checkBoxes}
                        onChangeHandler={onChangeHandler}
                        setUserApprove={setUserApprove}
                        setIsAcceptModal={setIsAcceptModal}
                        handleShow={handleShow}
                        canSubmit={canSubmit}
                        canCheckAll={canCheckAll}
                        updateTable={updateTable}
                        userNameOption={userNameOption}
                        gradeOption={gradeOption}
                        supervisorNameOption={supervisorNameOption}
                        divisionOption={divisionOption}
                        projectID={params.project_id}
                        calibratorID={params.calibrator_id}
                    />
                    
                    </>
                    :
                    <></>
                }
                
                {/* Action Buttons */}
                <div className="mt-4" style={{justifyContent: "space-between", display: "flex"}}>
                {
                    multipleAcceptJustification.length > 0?
                        <ActionButtonGradient
                            onClick={handleShowAcceptAll}
                            variant="success"
                            children={"Accept All Justification"}
                            size="small"
                        />
                        :
                        <div></div>
                }
                {
                    canSubmit && 
                    <ActionButtonGradient
                        onClick={handleShowSubmitModal}
                        variant='primary'
                        children={"Submit"}
                    />
                }
                </div>
            </div>
            
            <AcceptAllModal
                show={showAcceptAll}
                handleClose={handleCloseAcceptAll}
                handleOk={() => {
                    handleCloseAcceptAll()
                    acceptAllJustification()
                }}
            />
            
            <SubmitModal
                show={showSubmitModal}
                handleClose={handleCloseSubmitModal}
                handleOk={() => {
                    handleCloseSubmitModal()
                    submitReview()
                }}
            />
            
            <ApprovalModal
                show={show}
                handleClose={handleClose}
                isAccept={isAcceptModal}
                user={userApprove}
                setLoadingPage={setLoadingPage}
            />
            {userJustification && (
                <JustificationModalLatest
                    show={showJustification}
                    handleClose={handleCloseJustification}
                    user={userJustification}
                    projectID={params.project_id}
                    calibratorID={params.calibrator_id}
                    justificationModalUserID={userJustification?.EmployeeID}
                />
            )}

            {/* Scroll to Bottom Button */}
            {showScrollBottom && (
                <button
                    onClick={scrollToBottom}
                    style={{
                        position: 'fixed',
                        bottom: '20px',
                        right: '8px',
                        width: '36px',
                        height: '36px',
                        borderRadius: '50%',
                        background: 'linear-gradient(135deg, #02B4CC 0%, #0284C7 100%)',
                        border: 'none',
                        color: 'white',
                        fontSize: '20px',
                        cursor: 'pointer',
                        boxShadow: '0 4px 12px rgba(2, 180, 204, 0.4)',
                        zIndex: 999,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        transition: 'all 0.3s ease',
                        transform: showScrollBottom ? 'translateY(0)' : 'translateY(100px)',
                        opacity: showScrollBottom ? 1 : 0
                    }}
                    onMouseEnter={(e) => {
                        e.currentTarget.style.transform = 'translateY(-2px)'
                        e.currentTarget.style.boxShadow = '0 6px 16px rgba(2, 180, 204, 0.5)'
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.transform = 'translateY(0)'
                        e.currentTarget.style.boxShadow = '0 4px 12px rgba(2, 180, 204, 0.4)'
                    }}
                    aria-label="Scroll to bottom"
                >
                    <svg 
                        width="24" 
                        height="24" 
                        viewBox="0 0 24 24" 
                        fill="none" 
                        stroke="currentColor" 
                        strokeWidth="2" 
                        strokeLinecap="round" 
                        strokeLinejoin="round"
                    >
                        <path d="M12 5v14M19 12l-7 7-7-7"/>
                    </svg>
                </button>
            )}

            <Loading state={loadingPagestate}/>
            
        </div>
    )

}

export default SpmoDetail